"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getLinkSharingSettings = getLinkSharingSettings, exports.fetchSharingType = fetchSharingType, exports.convertToSharingSettings = convertToSharingSettings;

function getLinkSharingSettings(a, b) {
  var c = a.filter(function (a) {
    var b = a["public"],
        c = a.organisation;
    return b || c;
  });
  return c && c.length ? c[0] : {
    public: !1,
    canSearch: !1,
    organisation: void 0,
    role: b
  };
}

function fetchSharingType(a) {
  var b = a.isPublic,
      c = a.organisation,
      d = a.canSearch;
  return b ? "ANYONE" : c ? d ? "ANYONE_ORG" : "ANYONE_ORG_LINK" : "NONE";
}

function convertToSharingSettings(a, b) {
  return "ANYONE" === a ? {
    public: !0,
    organisation: void 0,
    canSearch: !0
  } : "ANYONE_ORG" === a ? {
    public: !1,
    organisation: {
      organisationId: b
    },
    canSearch: !0
  } : "ANYONE_ORG_LINK" === a ? {
    public: !1,
    organisation: {
      organisationId: b
    },
    canSearch: !1
  } : {
    public: !1,
    canSearch: !1,
    organisation: void 0
  };
}